class CancellationReasonsServices {
  static ITEMS_PER_PAGE = 20;

  static convertTableFilters(filters) {
    const params = {
      items_on_page: this.ITEMS_PER_PAGE,
      page: filters.page || 1,
      sort: filters.sortKey ? `${filters.sortKey}.${filters.sortType}` : 'created_at.asc',
    };
    if (filters.searchText?.trim()) {
      params['filters[string]'] = filters.searchText.trim();
    }
    return params;
  }
}

export default CancellationReasonsServices;
